import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ProjetcsService } from '../../projetcs.service';
import { GlobalService } from '../../../shared/services/global.service';


@Component({
    selector: 'app-edit-continuity-image',
    templateUrl: './edit-continuity-image.component.html',
    styleUrls: ['./edit-continuity-image.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditContinuityImageComponent implements OnInit {

	@Input() continuityImage: any;
	@Input() type: string;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();

	loading: boolean = true;
	project_id: string;
	viewData: any;
	filteredDays: any = [];
	filteredSets: any = [];

	formData: any = {
		'department_id':'',
		'tittle': '',
		'character_id':'',
		'day_of_history':'',
		'location_id':'',
		'location_set_id': '',
		'is_prop': ''
  }

  changeChapterScene(img) {
    const scene = this.viewData.scenes.find(x => x.id == img.scenes_id)
    if (scene) {
      img.chapter_scene = scene.chapter_scene
    }
  }

	close() {
		this.closeView.emit()
	}

	checkSets(ev) {
		this.filteredSets = this.viewData.location_sets.filter(element => element.location_id == this.formData.location_id);
		let index = this.filteredSets.findIndex(x => x.id == this.formData.location_set_id);
		if(index < 0){
			this.formData.location_set_id = '';
		}
	}

	checkDays(ev) {
		this.filteredDays =  this.viewData.character_days_of_history.filter(element => element.character_id == this.formData.character_id);
		let index = this.filteredDays.findIndex(x => x.day_of_history == this.formData.day_of_history);
		if(index < 0){
			this.formData.day_of_history = '';
		}
	}

	pendingData() {
    if (this.type == 'character' && (!this.formData.department_id || !this.formData.character_id || !this.formData.day_of_history)) {
      return true
    } else if (this.type == 'set') {

    } else if (this.type == 'scenes' && (!this.formData.scenes_id)) {
      return true
    }
		return false
	}

	loadData() {
		this._pS.getContAddImageData(this.project_id)
			.subscribe(
				data => {
					var rdata: any = data;
					this.viewData = rdata
					this.fillForm();
					this.loading = false;
				}
			)

	}

	fillForm(){
		console.log(this.continuityImage)
		this.formData.tittle = this.continuityImage.tittle || this.continuityImage.title;
		this.formData.department_id = this.continuityImage.department_id;

		if(this.type == 'character'){
			this.formData.character_id = this.continuityImage.character_id;
			this.filteredDays =  this.viewData.character_days_of_history.filter(element => element.character_id == this.formData.character_id);
			this.formData.day_of_history = this.continuityImage.day_of_history;
		} else if(this.type == 'set'){
			this.formData.location_id = this.continuityImage.location_id;
			this.formData.location_set_id = this.continuityImage.location_set_id;
			this.formData.is_prop = this.continuityImage.is_prop;
		} else if(this.type == 'scenes'){
			this.formData.scenes_id = this.continuityImage.scenes_id;
      this.formData.chapter_scene = this.continuityImage.chapter_scene;
		}
	}

	submitForm() {
		this.loading = true;
		let submitSubs = null
		if (this.type == 'scenes') {
		const formData = {
			...this.formData,
			title: this.formData.tittle
		}
		submitSubs = this._pS.editContinuitySceneImage(this.continuityImage.id,formData)
		} else {
		submitSubs =  this._pS.editContinuityImage(this.continuityImage.id, this.type, this.formData)
		}

		submitSubs.subscribe(
		data => {
			this.loading = false;
			this.notify.emit();
		},
		err => {
			this.loading = false;
			this.notify.emit();
		}
		)

	}

	constructor(private _loc: Location, private router: Router, private route: ActivatedRoute, private _pS: ProjetcsService, public _gS: GlobalService) { }

	ngOnInit() {
		this.project_id = this.route.snapshot.params['id'];
		this.loadData();
	}


}
